import {
    SET_MATCHES,
    SET_ACTIVES,
    SET_MATCHES_ACTIVES_LOADING,
    SET_MATCHES_ACTIVES_ERROR,
    RESET_MATCHES_ACTIVES,
} from "../constants";

const initialState = {
    matches: [],
    actives: [],
    loading: false,
    error: null,
};

const matchesActivesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MATCHES:
            return {
                ...state,
                matches: action.payload,
                error: null,
            };

        case SET_ACTIVES:
            return {
                ...state,
                actives: action.payload,
                error: null,
            };

        case SET_MATCHES_ACTIVES_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        case SET_MATCHES_ACTIVES_ERROR:
            return {
                ...state,
                error: action.payload,
            };

        case RESET_MATCHES_ACTIVES:
            return initialState;

        default:
            return state;
    }
};

export default matchesActivesReducer;
